import React, { useCallback, useState } from "react";
import TreeItem from "@material-ui/lab/TreeItem";
import TreeView from "@material-ui/lab/TreeView";

import type { FC, ChangeEvent } from "react";
import AddBoxOutlinedIcon from "../../../../../icons/OpenTree";
import RemoveOutlinedIcon from "../../../../../icons/CloseTree";
import { Hierarchy } from "../../../../common";

import { useStyles, useParentStyles, useItemStyles } from "./SubscriptionsItemsTree.styles";
import { useSubscriptionItemsHierarchy } from "./useSubscriptionItemsHierarchy";
import type { ISubscriptionsItemsTreeProps } from "./SubscriptionsItemsTree.types";
import { SUBSCRIPTION_ITEMS_GROUPS } from "./SubscriptionsItemsTree.constants";

export const SubscriptionsItemsTree: FC<ISubscriptionsItemsTreeProps> = (props) => {
  const { value, onChange, items } = props;

  const classes = useStyles();
  const classesParent = useParentStyles();
  const classesItem = useItemStyles();

  const hierarchies = useSubscriptionItemsHierarchy(items);

  const [expanded, setExpanded] = useState<string[]>(SUBSCRIPTION_ITEMS_GROUPS.map((g) => g.id));

  const handleSelect = useCallback(
    (e: ChangeEvent<{}>, nodeId: string) => {
      const targetHierarchy = Hierarchy.flat(hierarchies).find((h) => h.id === nodeId);
      if (targetHierarchy !== undefined && !targetHierarchy.children?.length) {
        onChange?.(Number(targetHierarchy.origin.id));
      }
    },
    [onChange, hierarchies]
  );

  const handleExpand = useCallback(
    (e: ChangeEvent<{}>, nodeIds: string[]) => {
      setExpanded(nodeIds);
    },
    [setExpanded]
  );

  return (
    <TreeView
      className={classes.treeView}
      defaultCollapseIcon={<RemoveOutlinedIcon />}
      defaultExpandIcon={<AddBoxOutlinedIcon />}
      expanded={expanded}
      selected={String(value)}
      onNodeSelect={handleSelect}
      onNodeToggle={handleExpand}
    >
      {hierarchies.map((hierarchy) => (
        <div key={hierarchy.id} className={classes.treeGroup}>
          <TreeItem nodeId={hierarchy.id} label={`${hierarchy.name} (${hierarchy.children.length})`} classes={classesParent}>
            {hierarchy.children.map((c) => (
              <TreeItem key={c.id} nodeId={c.id} label={c.name} classes={classesItem} />
            ))}
          </TreeItem>
        </div>
      ))}
    </TreeView>
  );
};
